module.exports = __webpack_public_path__ + "assets/img/16.84605d94.png";